import {Injectable} from '@angular/core';
import {from} from 'rxjs';
import {MapService} from '../map.service';
@Injectable()
export class DirectionsService {
  startingAddress = '';
  element: any;
  _directionsRenderer : any;

  constructor(private mapService: MapService)
  {}
  // init = this.initializeDirectionsRenderer;
  public window = window;

  setDirections(directionsPanelElement: unknown, dirMap?: any, config?: any){
    this.element = directionsPanelElement;
  }

  clearDirections() {
    if (!this._directionsRenderer) return this;

    this._directionsRenderer.setMap(null);
    this._directionsRenderer.setPanel(null);

    return this;
  }


  getDirections(startingAddress: any, endingAddress: any) {

    const directionsPromise = new Promise<void>((resolve, reject) => {

      const onRouteResult = (response: any, status: any) => {
        if (status === this.window.google.maps.DirectionsStatus.OK) {
          this._directionsRenderer.setDirections(response);

          //this sets the route to be displayed on the map and panel
          this._directionsRenderer.setMap(this.mapService._map);
          this._directionsRenderer.setPanel(this.element);

          // after a response is received successfully, we then
          // trigger the function to set the starting address
          // to be accessible for the "open map in Google Maps" link
          this._parseResponseAndSetStartingAddress(response);

          resolve();
        } else {
          reject();
        }
      };

      // let defer = $q.defer();
      const directionsService = new this.window.google.maps.DirectionsService();
      const request = {
        origin: startingAddress,
        destination: endingAddress,
        travelMode: this.window.google.maps.TravelMode.DRIVING
      };

      if (!this._directionsRenderer || !this.mapService || !this.mapService._map || !this.element) return reject();

      directionsService.route(request, onRouteResult);

    });
    const directionsObs = from(directionsPromise);
    return directionsObs;
  }
  // Initializes the directions renderer object
  init() {
    let directionsRendererOptions;

    const initDirectionsPromise = new Promise((resolve, reject) => {
      if (this._directionsRenderer) return resolve(this);

      if (!this.element) return reject('invalid directions panel element');
      if (!this.mapService) return reject('invalid map object');
      if (!this.mapService.mapConfig) return reject('invalid map config');

      directionsRendererOptions = Object.assign({}, this.mapService.mapConfig.directionsRendererOptions);
      directionsRendererOptions.panel = this.element;

      this._directionsRenderer = new this.window.google.maps.DirectionsRenderer(directionsRendererOptions);

      return resolve(this);
    });
    const initDirectionsObs = from(initDirectionsPromise);
    return initDirectionsObs;
  }

  public _getStartingAddress(){
    return this.startingAddress;
  }

  // here, we are checking to see if the start_address value exists and if so,
  // we are setting the startingAddress of the service object
  public _parseResponseAndSetStartingAddress(response: any){
    if(response && response.routes && response.routes[0] && response.routes[0].legs
      && response.routes[0].legs[0] && response.routes[0].legs[0].start_address){
      this.startingAddress = response.routes[0].legs[0].start_address;
    }
  }



}
